<template>
  <div class="empty-state">
    <div class="empty-state-inner">
      <div class="empty-state-image">
        <img
          :src="emptyImage"
          alt="empty_state"
          width="180"
          height="180"
          class="mb-8"
        />
      </div>
      <div class="empty-state-title">
        {{ $t('error.sorry_we_could_not_find_what_you_were_looking_for') }}
      </div>
      <div
        class="empty-state-subtitle"
        v-html="
          $sanitize($t('error.please_try_again_or_contact_support'), {
            allowedTags: ['a'],
          })
        "
      />
    </div>
  </div>
</template>

<script>
import emptyImage from '@/assets/images/empty-states/empty-state-revs.png'

export default {
  data() {
    return {
      emptyImage,
    }
  },
}
</script>

<style lang="scss" scoped>
.empty-state-inner {
  text-align: center;
  margin-top: 200px;
}

.empty-state-title {
  font-size: $font-size-20;
  font-weight: 600;
  text-align: center;
  color: $color-blue-grey-darken3;
  max-width: 300px;
  margin: 0 auto;
  display: block;
}

.empty-state-subtitle {
  margin-top: 5px;
  font-size: $font-size-16;
  font-weight: 300;
  text-align: center;
  color: $color-blue-grey-darken3;
}
</style>
